<template>
  <div>
      <v-data-table
        v-model="selected"
        :loading="loading"
        loading-text="Loading subscriptions"
        :headers="headers"
        :items="userSubscriptions"
        item-key="id"
        show-select
        :search="search"
        sort-by="unit.alias"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Devices</v-toolbar-title>
          </v-toolbar>
          <v-alert v-if="error" text dense type="error">
            {{ error }}
          </v-alert>
          <v-toolbar flat>
            <v-text-field
              :disabled="deleting"
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            />
            <v-spacer/>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn :disabled="selected.length === 0 || deleting || loading" v-show="$vuetify.breakpoint.mdAndUp" v-on="on" text icon color="delete" @click="onClickRemoveSubscription"><v-icon>mdi-delete-forever</v-icon></v-btn>
              </template>
              <span>Remove selected subscriptions</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn :disabled="deleting || loading" v-on="on" text icon color="add" @click="onclickAddSubscription"><v-icon>mdi-plus-circle</v-icon></v-btn>
              </template>
              <span>Add subscriptions</span>
            </v-tooltip>
          </v-toolbar>
        </template>

        <template v-slot:header.data-table-select="{ on, props }">
          <v-simple-checkbox :disabled="deleting" :ripple="false" v-bind="props" v-on="on"/>
        </template>

        <template v-slot:item.data-table-select="{ isSelected, select }">
          <v-simple-checkbox :disabled="deleting" :ripple="false" :value="isSelected" @input="select($event)"/>
        </template>

        <template v-slot:item.loadingBar="{ item }">
          <v-progress-circular v-if="item.loading" indeterminate color="loading"/>
        </template>
        <template v-slot:item.unit.transientFamily="{ item }">
          <v-icon>{{getFamilyIcon(item.unit.transientFamily)}}</v-icon>
        </template>

      </v-data-table>

      <v-dialog scrollable :value="addSubscriptionModal"  persistent :fullscreen="$vuetify.breakpoint.smAndDown" max-width="60vw">
          <AddSubscriptionsForm @close-form="closeAddSubscriptionModal"/>
      </v-dialog>
    <v-footer v-show="$vuetify.breakpoint.smAndDown && selected.length > 0" class="sticky-footer">
      <v-btn
        :disabled="selected.length === 0 || deleting || loading"
        class="error"
        @click="onClickRemoveSubscription">
        Delete Selected
      </v-btn>
    </v-footer>
  </div>
</template>

<script>
import AddSubscriptionsForm from './AddSubscriptionsForm'
import bulkOperation from '../../mixins/bulkOperation'
import familyIcon from '../../mixins/familyIcon'

export default {
  name: 'UserSubscriptionsList',
  mixins: [bulkOperation, familyIcon],
  components: { AddSubscriptionsForm },
  props: ['userSubscriptions', 'error', 'loading', 'userId'],
  data: () => ({
    addSubscriptionModal: false,
    selected: [],
    deleting: false,
    search: '',
    headers: [
      {
        text: '',
        align: 'start',
        dense: true,
        value: 'unit.transientFamily',
        sortable: false
      },
      {
        text: 'Alias',
        value: 'unit.alias'
      },
      {
        text: 'Note',
        value: 'unit.notes'
      },
      {
        text: 'Subscription number',
        value: 'subscriptionNumber'
      },
      {
        text: '',
        value: 'loadingBar',
        sortable: false
      }
    ]
  }),

  methods: {
    onclickAddSubscription: function () {
      this.addSubscriptionModal = true
    },
    closeAddSubscriptionModal: function () {
      this.addSubscriptionModal = false
    },

    onClickRemoveSubscription: function () {
      let removeSubscriptionAccessPromises = this.selected.map(subscription => this.$store.dispatch('subscription/removeSubscriptionAccess', { user: { id: this.userId, email: this.userEmail }, subscription: { id: subscription.id, alias: subscription.unit.alias } }))
      this.executeBulkOperation(removeSubscriptionAccessPromises)
    },

    beforeBulk: function () {
      this.deleting = true
      for (let subscription of this.selected) {
        subscription.loading = true
      }
    },

    handleBulkError: function (error) {
      console.error(error)
    },

    handleBulkSuccess: function (responses) {
      let subscriptionIds = responses.map(e => e.subscription.id)
      this.$store.dispatch('user/removeSubscriptionsFromUser', subscriptionIds)
      let aliasString = ''
      for (let response of responses) {
        aliasString += response.subscription.alias + ', '
      }

      aliasString = aliasString.substr(0, aliasString.length - 2)
      this.$store.commit('setSuccessMessage', aliasString + ' has been removed from the user')
    },

    afterBulk: function () {
      this.deleting = false
      for (let subscription of this.selected) {
        subscription.loading = false
      }
      this.selected = []
    }
  },
  computed: {
    userEmail: function () {
      return this.$store.state.user.currentUser.data.email
    }
  }
}
</script>

<style scoped>

</style>
